import React from 'react';
import _ from 'lodash';
import classNames from 'classnames';

import {
  getAgeAdjustedTotal
} from 'util/lifterHelper';

const AgeAdjustedTotalCell = ({data, column, meet, style}) => {
  const lifter = data;
  const division = lifter.division;

  if(lifter.row === 'header') {
    return (<div style={style} className="table-cell-inner">{column.label}</div>);
  } else if(lifter.row === 'title') {
    return (
      <div style={style} className="table-cell-inner" />
    );
  } else {
    return (
      <div style={style} className={classNames('table-cell-inner', {'scored-column': division.scoreBy === 'AGE_POINTS'})}>
        {_.round(getAgeAdjustedTotal(lifter, division._id, meet), [2])}
      </div>
    );
  }
};

export default AgeAdjustedTotalCell;
